// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs{font-size:12px;width:100%;font-weight:500;padding:0;font-family:'Fira Code';display:flex;align-items:center;flex-wrap:wrap}.breadcrumbs-item{color:#1e2b4e;cursor:pointer;display:flex;align-items:center;justify-content:center}.breadcrumbs-item-content{padding:0 0.25rem}.breadcrumbs-item-content:hover{background:#f5f7fa}.breadcrumbs__slash{color:#d4d8e7}\n", ""]);
// Exports
module.exports = exports;
